// Yforia theme v0.1: intentionally lightweight.

document.addEventListener('click', function(event) {
  var plus = event.target.closest('[data-yf-qty-plus]');
  var minus = event.target.closest('[data-yf-qty-minus]');
  if (!plus && !minus) return;
  var wrap = event.target.closest('.yf-pdp-qty');
  if (!wrap) return;
  var input = wrap.querySelector('input[name="quantity"]');
  if (!input) return;
  var current = parseInt(input.value || '1', 10);
  if (plus) input.value = current + 1;
  if (minus) input.value = Math.max(1, current - 1);
});

/* v1.0.0 Mobile menu */
(function () {
  function getHeader(el) {
    return el && el.closest ? el.closest('.yf-header') : null;
  }

  function openMenu(header) {
    if (!header) return;
    var drawer = header.querySelector('[data-yf-mobile-drawer]');
    var openButton = header.querySelector('[data-yf-menu-open]');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('yf-menu-is-open');
    if (openButton) openButton.setAttribute('aria-expanded', 'true');
    var firstLink = drawer.querySelector('a, button');
    if (firstLink) setTimeout(function () { firstLink.focus({ preventScroll: true }); }, 50);
  }

  function closeMenu(header) {
    if (!header) return;
    var drawer = header.querySelector('[data-yf-mobile-drawer]');
    var openButton = header.querySelector('[data-yf-menu-open]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('yf-menu-is-open');
    if (openButton) {
      openButton.setAttribute('aria-expanded', 'false');
      openButton.focus({ preventScroll: true });
    }
  }

  document.addEventListener('click', function (event) {
    var openButton = event.target.closest('[data-yf-menu-open]');
    if (openButton) {
      event.preventDefault();
      openMenu(getHeader(openButton));
      return;
    }

    var closeTrigger = event.target.closest('[data-yf-menu-close], [data-yf-menu-link]');
    if (closeTrigger) {
      closeMenu(getHeader(closeTrigger));
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.yf-mobile-drawer.is-open').forEach(function (drawer) {
      closeMenu(getHeader(drawer));
    });
  });
})();

/* v1.0.8 cart update fix */
(function () {
  var debounceTimers = {};

  function cartUpdateUrl() {
    var root = '/';
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      root = window.Shopify.routes.root;
    }
    return root.replace(/\/$/, '/') + 'cart/update.js';
  }

  function clampQuantity(value) {
    var parsed = parseInt(value || '0', 10);
    if (isNaN(parsed)) parsed = 0;
    return Math.max(0, parsed);
  }

  function setUpdating(form, isUpdating) {
    if (!form) return;
    form.classList.toggle('is-updating', !!isUpdating);
    var updateButton = form.querySelector('[data-yf-cart-update]');
    if (updateButton) {
      updateButton.disabled = !!isUpdating;
      updateButton.setAttribute('aria-busy', isUpdating ? 'true' : 'false');
      updateButton.textContent = isUpdating ? 'Updating…' : 'Update Cart';
    }
  }

  function fallbackSubmit(form) {
    if (!form) return;
    var hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = 'update';
    hidden.value = 'Update cart';
    form.appendChild(hidden);
    form.submit();
  }

  function collectUpdates(form) {
    var updates = {};
    if (!form) return updates;
    form.querySelectorAll('[data-yf-cart-qty-input]').forEach(function (input) {
      var key = input.getAttribute('data-yf-cart-line-key');
      if (!key) return;
      updates[key] = clampQuantity(input.value);
    });
    return updates;
  }

  function sendUpdates(form) {
    if (!form) return;
    if (!window.fetch) {
      fallbackSubmit(form);
      return;
    }

    var updates = collectUpdates(form);
    setUpdating(form, true);

    fetch(cartUpdateUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart update failed');
        return response.json();
      })
      .then(function () {
        window.location.reload();
      })
      .catch(function () {
        fallbackSubmit(form);
      });
  }

  function scheduleUpdate(form, input) {
    if (!form || !input) return;
    var id = input.id || input.getAttribute('data-yf-cart-line-key') || 'cart';
    clearTimeout(debounceTimers[id]);
    debounceTimers[id] = setTimeout(function () {
      sendUpdates(form);
    }, 450);
  }

  document.addEventListener('click', function (event) {
    var plus = event.target.closest('[data-yf-cart-qty-plus]');
    var minus = event.target.closest('[data-yf-cart-qty-minus]');
    if (!plus && !minus) return;

    var wrap = event.target.closest('[data-yf-cart-qty]');
    if (!wrap) return;
    var input = wrap.querySelector('[data-yf-cart-qty-input]');
    if (!input) return;

    var current = clampQuantity(input.value);
    if (plus) input.value = current + 1;
    if (minus) input.value = Math.max(1, current - 1);

    scheduleUpdate(event.target.closest('[data-yf-cart-form]'), input);
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-yf-cart-qty-input]');
    if (!input) return;
    input.value = clampQuantity(input.value);
    scheduleUpdate(input.closest('[data-yf-cart-form]'), input);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-yf-cart-form]');
    if (!form) return;

    var submitter = event.submitter;
    if (submitter && submitter.getAttribute('name') === 'checkout') return;

    event.preventDefault();
    sendUpdates(form);
  });
})();
